import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { corporateColor } from '../../../../theme/colors'
import { DOBRA } from '../../../../theme/fonts'

export const Header = () => {
  return (
    <View style={{ flexDirection: 'row' }}>
      <View style={{ flex: 1.2 }}>
        <Text style={style.subTitle}>Estanque</Text>
      </View>
      <View style={{ flex: 1 }}>
        <Text style={style.subTitle}>Nominal</Text>
      </View>
      <View style={{ flex: 1 }}>
        <Text style={style.subTitle}>Útil</Text>
      </View>
      <View style={{ flex: 1.2 }}>
        <Text style={style.subTitle}>Stock</Text>
      </View>
    </View>
  )
}

const style = StyleSheet.create({
  subTitle: {
    fontFamily: DOBRA,
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 20,
    color: corporateColor,
  },
})
